<template>
  <div :class="['ft-input-wrap', wrapClass]">
    <textarea
      v-if="type === 'textarea'"
      :value="value"
      :type="type"
      :class="['ft-input', inputClass]"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      @input="onInput"
    ></textarea>
    <input
      v-else
      :value="value"
      :type="type"
      :class="['ft-input', inputClass]"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      @input="onInput"
    />
    <ft-close-icon v-show="calcShowClose" class="icon-clear" @clear="onClear" />
  </div>
</template>

<script>
export default {
  name: 'FtInput',
  props: {
    value: {
      default() {
        return '';
      }
    },
    type: {
      default() {
        return 'text';
      }
    },
    wrapClass: {
      default() {
        return '';
      }
    },
    inputClass: {
      default() {
        return '';
      }
    },
    maxlength: {
      default() {
        return '';
      }
    },
    placeholder: {
      default() {
        return '';
      }
    },
    disabled: {
      default() {
        return false;
      }
    },
    readonly: {
      default() {
        return false;
      }
    },
    clearable: {
      default() {
        return true;
      }
    },
    showClose: {
      default() {
        return true;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    calcShowClose() {
      return this.showClose && String(this.value).length;
    }
  },
  methods: {
    onInput(e) {
      const val = e.target.value || '';
      this.$emit('input', String(val).trim());
    },
    onClear() {
      this.$emit('input', '');
    }
  }
};
</script>

<style lang="scss" scoped>
.ft-input-wrap {
  display: inline-block;
  position: relative;
  .ft-input {
    width: 100%;
    height: 100%;
    outline: none;
    border: 0;
    resize: none;
  }
  .icon-clear {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// ftInput.vue